import { render } from "./protocol_inside_winners.vue?vue&type=template&id=d0f3d6c8"
import script from "./protocol_inside_winners.vue?vue&type=script&lang=js"
export * from "./protocol_inside_winners.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/host/imc/tender/dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vue/js/components/sale/protocol/inside/block/protocol_inside_winners.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d0f3d6c8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d0f3d6c8', __exports__)) {
    console.log('reload')
    api.reload('d0f3d6c8', __exports__)
  }
  
  module.hot.accept("./protocol_inside_winners.vue?vue&type=template&id=d0f3d6c8", () => {
    console.log('re-render')
    api.rerender('d0f3d6c8', render)
  })

}


export default __exports__